import { Card } from '@unmind/design-system';
import { rem } from 'polished';
import styled from 'styled-components';

export const Section = styled('section')`
  padding: ${rem(24)} ${rem(24)} ${rem(100)} ${rem(24)};

  & > article {
    margin-bottom: ${rem(16)};
  }

  @media screen and (min-width: 576px) {
    padding-bottom: ${rem(24)};
  }

  @media screen and (min-width: 994px) {
    & > article {
      margin-bottom: ${rem(24)};
    }
  }

  @media screen and (min-width: 1101px) {
    padding: ${rem(40)} ${rem(48)};
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;

    & > article,
    & > section {
      width: calc((100% - ${rem(24)}) / 2);
      margin-bottom: auto;
    }
  }

  .formcard {
    padding: 0;
    padding-top: ${rem(24)};
  }

  form > fieldset,
  form > h2,
  form > .wrapper {
    padding: ${rem(0)} ${rem(24)} ${rem(24)};
  }

  form .footer {
    padding: ${rem(24)};
  }
`;

export const CardService = styled(Card)`
  font-size: ${rem(14)};
  color: ${({ theme }) => theme.colors.text.primary};

  h1,
  h2,
  h3,
  h4,
  p,
  li {
    line-height: 140%;
  }

  .title {
    margin-bottom: ${rem(12)};
    font-size: ${rem(16)};
    font-weight: 600;
  }

  ul {
    margin: 0;
  }
`;

export const CardServiceIntro = styled(Card)`
  margin-bottom: ${rem(20)};

  svg {
    margin-bottom: ${rem(15)};
    display: block;
  }

  h1 {
    margin-bottom: ${rem(16)};
    font-size: ${rem(28)};
    font-weight: 600;
  }

  p {
    margin: 0 0 ${rem(16)} 0;
    font-size: ${rem(16)};
    font-weight: 500;
    color: ${({ theme }) => theme.colors.text.secondary};

    &:last-child {
      margin-bottom: 0;
    }
  }
`;
